export const numberRegex = /^[0-9]+$/;
export const phonecodeRegex = /^[0-9+]+$/;
export const nicRegex = /^[0-9a-zA-Z]+$/;
// export const priceRegex = /^-?\d*\.?\d+$/;
export const priceRegex = /^\d+(\.\d{1,2})?$/;
export const zipRegex = /^[a-zA-Z0-9]+$/;
export const emailRegex = /^(?!\.)[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}$/;
// export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const charRegex = /^[a-zA-Z]+$/;
export const nameRegex = /^[a-zA-Z\s]+$/;
export const percentageRegex = /^(?:$|^[1-9]\d?$|100)$/;
export const nospaceRegex = /^\S*$/;

export const handleInputKeyUpReg = (
	event,
	setterFunction = () => {},
	validationregex,
	method = 1,
	key,
) => {
	const input = String(event.target.value).split('');
	const validinput = [];

	const validation = validationregex.test(input);
	input.forEach((data) => {
		if (validationregex.test(data)) {
			validinput.push(data);
		}
	});
	if (method === 1) {
		setterFunction(validinput.join(''));
	}
	if (method === 2) {
		setterFunction((tre) => {
			const temp = {
				...tre,
			};
			temp[key] = validinput.join('');
			return temp;
		});
	}
};

export const handleCheckInputKeyUpReg = (inputdata, setterFunction = () => {}, validationregex) => {
	const validation = validationregex.test(inputdata);
	if (!validation) {
		setterFunction({
			error: true,
			msg: 'Only integers or decimals numbers with up to 2 decimal places accepted',
		});
		return false;
	} else {
		return true;
	}
};

export const handleCheckInputPhoneCode = (
	inputdata,
	setterFunction = () => {},
	validationregex,
) => {
	const validation = validationregex.test(inputdata);

	if (!validation) {
		setterFunction({
			error: true,
			msg: 'Only integers and + Symbol accepted',
		});
		return false;
	} else {
		return true;
	}
};

export const handleCheckInputNumbers = (inputdata, setterFunction = () => {}, validationregex) => {
	const validation = validationregex.test(inputdata);

	if (!validation) {
		setterFunction({
			error: true,
			msg: 'Only integers accepted',
		});
		return false;
	} else {
		return true;
	}
};

export const handleCheckInputNic = (inputdata, setterFunction = () => {}, validationregex) => {
	const validation = validationregex.test(inputdata);

	if (!validation) {
		setterFunction({
			error: true,
			msg: 'Only Integers and Character accepted',
		});
		return false;
	} else {
		return true;
	}
};

export const checkInput = (
	inputdata,
	setterFunction = () => {},
	validationregex,
	inputkey,
	message,
) => {
	if ((inputkey === 'deduct_amt' || inputkey === 'Deductamt') && inputdata[inputkey] === '0') {
		setterFunction((pre) => {
			const temp = { ...pre };
			temp[inputkey] = {
				error: true,
				msg: 'Amount cannot be 0',
			};
			return temp;
		});
		return false;
	}

	const validation = validationregex.test(inputdata[inputkey]);

	if (!validation) {
		setterFunction((pre) => {
			const temp = { ...pre };
			temp[inputkey] = {
				error: true,
				msg: message,
			};
			return temp;
		});
		return false;
	} else {
		return true;
	}
};

export const multiinputcheck = (
	inputArray = [],
	input = {},
	errorsetter,
	validatedobj = {},
	requiredText,
) => {
	const cansendapi = [];
	inputArray.forEach((inputkey) => {
		if (!input[inputkey]) {
			cansendapi.push(false);
			errorsetter((pre) => {
				const temp = { ...pre };
				temp[inputkey] = { error: true, msg: requiredText };
				return temp;
			});
		} else {
			if (validatedobj[inputkey]) {
				const out = checkInput(
					input,
					errorsetter,
					validatedobj[inputkey][0],
					inputkey,
					validatedobj[inputkey][1],
				);
				cansendapi.push(out);
			} else {
				cansendapi.push(true);
			}
		}
	});
	if (cansendapi.includes(false)) {
		return false;
	} else {
		return true;
	}
};
